import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  APIDataProvider,
  ApiPaths,
  TApiPaginationResponse,
  TApiResponse,
} from '../../api';
import { IQuestionTag } from '../QuestionSlice';

export interface IAdminGetQuestionTagList {
  limit: number;
  offset: number;
  name: string;
}

const apiDataProvider = new APIDataProvider();

export const getTagsList = createAsyncThunk(
  'tags/list',
  async (data: IAdminGetQuestionTagList) => {
    const response = await apiDataProvider.get<
      TApiResponse<TApiPaginationResponse<IQuestionTag>>
    >(
      `${ApiPaths.tags}/list?limit=${data.limit}&offset=${data.offset}&name=${data.name}`
    );

    return response.data;
  }
);
